import { getMandatoryInstructions } from "pages/project/common/taskBase/sidebar/instructions/taskInstructionGroups";
import { useTaskInstructionList } from "query/task.query";
import { useMemo } from "react";

/** Whether the task has mandatory free-text instructions (warning icon). Does not gate downloads. */
export const useHasMandatoryInstructions = (taskId: string, enabled = true) => {
  const { instructions, instructionsAcknowledgedAt, isLoading, error } = useTaskInstructionList(taskId, enabled);
  const mandatoryInstructions = useMemo(() => getMandatoryInstructions(instructions), [instructions]);

  return {
    mandatoryInstructions,
    hasMandatoryInstructions: mandatoryInstructions.length > 0,
    instructionsAcknowledgedAt,
    isLoading,
    error,
  };
};
